import { useEffect, useState } from "react";
import { TranslationKey } from "../translation/translator";

export class ErrorWithDisplayMessage extends Error {
  constructor(message: TranslationKey) {
    super(message);
    this.name = "ErrorWithDisplayMessage";
  }
}

export function isErrorWithDisplayMessage(
  error: unknown,
): error is ErrorWithDisplayMessage {
  return error instanceof ErrorWithDisplayMessage;
}

export function useUnrecoverableError() {
  const [unrecoverableError, setUnrecoverableError] = useState<Error | null>(
    null,
  );

  const setCustomErrorWithDisplayMessage = (textKey: TranslationKey) => {
    setUnrecoverableError(new ErrorWithDisplayMessage(textKey));
  };

  const setCustomError = (error: Error | ErrorWithDisplayMessage | string) => {
    if (error instanceof ErrorWithDisplayMessage || error instanceof Error) {
      setUnrecoverableError(error);
    } else {
      setUnrecoverableError(new Error(error));
    }
  };

  useEffect(() => {
    if (unrecoverableError) {
      throw unrecoverableError;
    }
  }, [unrecoverableError]);

  return {
    setUnrecoverableError,
    setCustomError,
    setCustomErrorWithDisplayMessage,
  };
}
